<template>
	<div class="cruise">
		<!-- 导航栏 -->
		<back-to :title="productList.productName"></back-to>
		<!-- 轮播 -->
		<section class="detailSwiper">
			<van-swipe class="detailSwiper-swiper-bg" :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item, index) in productList.images" :key="index">
					<img v-lazy="item" />
				</van-swipe-item>
			</van-swipe>
		</section>
		<!-- 价钱 -->
		<section class="cruise-common">
			<div class="cruise-price_top">
				<font>￥</font>
				<p>{{productList.price}}</p>
				<font>起</font>
			</div>
			<div class="cruise-price_title">
				{{productList.productName}}
			</div>
			<div class="cruise-price_type">
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_01.png?v='+random"
						alt="">
					<p>{{productList.themes}}</p>
					<font>出游人群</font>
				</span>
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_02.png?v='+random"
						alt="">
					<p>{{productList.crowds}}</p>
					<font>出游主题</font>
				</span>
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_03.png?v='+random"
						alt="">
					<p>提前{{productList.advanceEnrollDay}}天报名</p>
					<font>报名时间</font>
				</span>
			</div>
		</section>
		<section class="cruise-common cruise-serve">
			<span>服务</span>
			<span>
				<img v-if="productList.confirmType == 2" class="ad8"
					:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_08.png?v='+random" alt="">
				<img v-if="productList.confirmType == 1" class="ad8"
					:src="'https://sweetour-pic.obs.myhwclouds.com/first.png?v='+random" alt="">
				<p v-if="productList.confirmType == 2">该商品在支付成功需等待客服确认</p>
				<p v-if="productList.confirmType == 1">该商品在支付成功后即刻确认</p>
			</span>
		</section>
		<section class="cruise-common cruise-package">
			<div class="cruise-package_top">
				<label for="">
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_09.png?v='+random"
						alt="">
					<p>选择房型</p>
				</label>
				<label for=""></label>
			</div>
			<div class="meal-item">
				<label for="" v-for="(item,index) in productList.cabin" :key="index"
					:class="packegeSelectIndex == index? 'meal-item-change':''" @click="change(index)">
					<p>{{item.name}}</p>
					<font>￥{{item.minPrice}}</font>
				</label>
			</div>
		</section>
		<section class="cruise-sticky">
			<van-tabs v-model="active" scrollspy sticky offset-top="46" color="#ffcc03">
				<van-tab title="商品详情">
					<!-- 基本信息 -->
					<section class="cruise-common cruise-sticky_basic">
						<h2 class="cruise-sticky_title">基本信息</h2>
						<ul>
							<li v-for="(item,index) in productList.shipInfos" :key="index">
								<h3>{{item.key}}</h3>
								<label for="" v-if="index==0">
									<p v-for="(child,key) in item.array" :key="key">{{child}}</p>
								</label>
								<label for="" v-else>{{item.value}}</label>
							</li>
						</ul>
					</section>
					<!-- 行程介绍 -->
					<section class="cruise-common cruise-sticky_trip">
						<h2 class="cruise-sticky_title">行程介绍</h2>
						<div class="cruise-sticky_Collapse">
							<van-collapse v-model="activeName" accordion>
								<van-collapse-item v-for="(item,index) in productList.trip" :key="index" :name="index">
									<template #title>
										<div class="sticky_Collapse-title">
											<span>
												<label for="">D{{item.sort}}</label>
											</span>
											<span>{{item.title}}</span>
										</div>
									</template>
									<template>
										<div class="sticky_Collapse-content">
											<span class="sticky_Collapse-content01">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_15.png?v='+random"
														alt="">
													<font>详情</font>
												</label>
												<label for="" class="content01-b">
													<div v-html="item.details"></div>
												</label>
											</span>
											<span class="sticky_Collapse-content02">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_16.png?v='+random"
														alt="">
													<font>饮食</font>
												</label>
												<label for="" class="content01-b">
													<p>早餐：{{item.breakfast}}</p>
													<p>午餐：{{item.lunch}}</p>
													<p>晚餐：{{item.dinner}}</p>
												</label>
											</span>
											<span class="sticky_Collapse-content02">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_17.png?v='+random"
														alt="">
													<font>启航时间</font>
												</label>
												<label for="" class="content01-b">
													<p>启航时间：{{item.setSailAt}}</p>
													<p>抵达时间：{{item.arrivalAt}}</p>
													<p>停止登船时间：{{item.stopBoardingAt}}</p>
												</label>
											</span>
										</div>
									</template>
								</van-collapse-item>
							</van-collapse>
						</div>
					</section>
					<!-- 产品概况 -->
					<section class="cruise-common cruise-sticky_overview">
						<h2 class="cruise-sticky_title">产品概况</h2>
						<div v-html="productList.productOverview"></div>
					</section>
				</van-tab>
				<van-tab title="费用说明">
					<section class="cruise-common">
						<h2 class="cruise-sticky_title">费用说明</h2>
						<div class="cruise-sticky_cost" v-for="(item,index) in productList.cost_Info" :key="index"
							v-if="index != 3">
							<h3>{{cost_array[index]}}</h3>
							<div v-html="item.content"></div>
						</div>
					</section>
				</van-tab>
				<van-tab title="其他信息">
					<section class="cruise-common">
						<h2 class="cruise-sticky_title">其他信息</h2>
						<div class="cruise-sticky_cost">
							<!-- <h3>{{item.title}}</h3> -->
							<div v-html="productList.others"></div>
						</div>
					</section>
				</van-tab>
			</van-tabs>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<a href="tel:02425836666">咨询</a>
			<span class="" @click="next">立即下单</span>
			<!-- <span v-else class="grays">选择购买</span> -->
		</section>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'cruise',
		components: {
			BackTo
		},
		data() {
			return {
				packegeSelectIndex: 0,
				productList: [],
				random: Math.random(),
				active: 0,
				activeName: 0,
				cost_array: ["费用包含", "费用不包含", "温馨提示", "其他说明"]
			}
		},
		filters: {
			formatDate(date) {
				let getMonth = new Date(date).getMonth() + 1;
				let getDate = new Date(date).getDate();
				return `${getMonth}/${getDate}`
			}
		},
		created() {
			this.id = this.$route.query.id
		},
		mounted() {
			this.getData()
		},
		methods: {
			next() {
				this.$router.push({
					path: '/cruiseChoice',
					query: {
						'id': this.$route.query.id,
						'image':this.productList.images[0]
					}
				})
			},
			getData() {
				var jsonData = {
					id: this.$route.query.id
				}
				this.$get(
					this.$domainUrl + '/ShipApp/GetShip', jsonData
				).then(res => {
					console.log(res)
					res.data.themes = res.data.tags.theme.split(',')[0]
					res.data.crowds = res.data.tags.crowd.split(',')[0]
					res.data.shipInfos.forEach(element => {
						element.array = element.value.split(",")
					});
					res.data.others = res.data.cost_Info[3].content
					this.productList = res.data
				})
			},
			change(index) {
				if (this.packegeSelectIndex == index) {
					return
				}
				this.packegeSelectIndex = index
			}
		}
	}
</script>
<style>
	.cruise .detailSwiper,
	.cruise .detailSwiper-swiper-bg {
		width: 100%;
		height: 700px;
		z-index: -1
	}

	.cruise .detailSwiper-swiper-bg img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.cruise-common {
		width: 100%;
		border-bottom: 20px solid #f7f7f7;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.cruise-price_top {
		font-size: 48px;
		color: #ff401a;
		display: flex;
		align-items: baseline;
		padding: 18px 0 12px 0;
	}

	.cruise-price_top font {
		padding: 0 6px;
		font-size: 36px;
	}

	.cruise-price_title {
		font-size: 32px;
		color: #333;
		font-weight: bold;
	}

	.cruise-price_type {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 36px 0 30px 0;
		/* border-bottom: 1px solid #e6e6e6; */
	}

	.cruise-price_type img {
		height: 33px;
		width: 33px;
		margin-bottom: 12px;
	}

	.cruise-price_type span {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #333;
		flex: 1;
	}

	.cruise-price_type font {
		font-size: 22px;
		color: #919499
	}

	.cruise-price_ad {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
		height: 88px;
		width: 100%;
	}

	.cruise-price_ad label {
		display: flex;
		align-items: center;
	}

	.cruise-price_ad p {
		font-size: 24px;
		color: #919499;
		margin-left: 8px;
	}

	.cruise-price_ad .ad5 {
		width: 132px;
		height: 39px;
	}

	.cruise-price_ad .ad1 {
		height: 26px;
		width: 26px;
		margin-left: 20px;
	}

	.cruise-price_ad .ad7 {
		height: 20px;
		width: 10px;

	}

	.cruise-price_ad label:last-child {
		margin-left: auto;
	}

	.cruise-serve {
		padding-top: 28px;
		padding-bottom: 28px;
		display: flex;
	}

	.cruise-serve p {
		font-size: 24px;
		color: #333;
		margin-top: 24px;
	}

	.cruise-serve span {
		font-size: 24px;
		color: #919499;
		margin-right: 20px;
		display: grid;
	}

	.cruise-serve .ad8 {
		width: 110px;
		height: 26px;
		margin-top: 4px;
	}

	.cruise-package_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 88px;
	}

	.cruise-package_top label {
		display: flex;
		align-items: baseline;
	}

	.cruise-package_top label:first-child {
		font-size: 32px;
		color: #333;
		font-weight: bold;
	}

	.cruise-package_top label:first-child img {
		height: 24px;
		width: 20px;
		margin-right: 10px;
	}

	.cruise-package_top label:last-child {
		color: #fca537;
		font-size: 24px;

	}

	.cruise-package_top label:last-child img {
		height: 20px;
		width: 10px;
		margin-left: 10px;
	}

	.cruise .meal-item {
		margin-top: 14px;
		margin-bottom: 30px;
	}

	.cruise .meal-item label {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 25px;
		border: 1px solid #fff;
		border-radius: 10px;
		color: #333;
		width: 100%;
		padding: 26px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.cruise .meal-item p {
		font-size: 26px;
		color: #333;
	}

	.cruise .meal-item font {
		font-size: 24px;

	}

	.cruise .meal-item-change {
		border: 1px solid #fca537 !important;
		color: #fca537 !important;
	}

	.cruise .meal-item-change p {
		color: #fca537 !important;
	}


	.cruise .date {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin: 32px auto 26px;
		box-sizing: border-box;
	}

	.cruise .data-item {
		border: 1px solid #f1f1f1;
		height: 90px;
		width: 128px;
		text-align: center;
		font-size: 24px;
		margin-left: 10px;
		border-radius: 5px;
		margin-bottom: 10px;
	}

	.cruise .data-item-change {
		border: 1px solid#fca500 !important;
	}

	.cruise .data-item label {
		color: #333;
		font-weight: bold;
		margin-top: 15px;
		display: inline-block;
	}

	.cruise .data-item p {
		color: #ff5e00;
	}

	.cruise-sticky_title {
		height: 88px;
		line-height: 88px;
		font-size: 32px;
		color: #333;
	}

	.cruise-sticky_basic li {
		border-top: 1px solid #f1f1f1;
		display: flex;
		padding: 15px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.cruise-sticky_basic h3 {
		line-height: 75px;
		font-size: 24px;
		color: #999;
		width: 176px;
		text-align: left;
		font-weight: normal;
	}

	.cruise-sticky_basic label {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		font-size: 24px;
	}

	.cruise-sticky_basic p {
		height: 40px;
		line-height: 40px;
		background: #f1f1f1;
		color: #333;
		padding: 0 10px;
		margin-right: 8px;
		margin-bottom: 8px;
	}

	.cruise-sticky_package {
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #333;
		margin-top: 20px;
	}

	.cruise-sticky_package p {
		height: 56px;
		margin-left: 30px;
		background: #ffcc03;
		font-size: 24px;
		text-align: center;
		line-height: 56px;
		border-radius: 200px;
		padding: 0 24px;
	}

	.cruise-sticky_Collapse {
		width: 100%;
		margin-top: 32px;
	}

	.sticky_Collapse-title {
		display: flex;
		align-items: center;

	}

	.cruise .sticky_Collapse-title span:first-child {
		position: relative;
		left: -26px;
		background-color: #fca537;
		width: 116px;
		height: 48px;
		border-top-right-radius: 24px;
		border-bottom-right-radius: 24px;
		text-align: center;
		line-height: 48px;
	}

	.cruise .sticky_Collapse-title label {
		font-size: 34px;
		color: #fff;
		font-weight: bold;
	}

	.cruise .sticky_Collapse-title span:last-child {
		margin-left: 22px;
		font-size: 30px;
		font-weight: bold;
		display: flex;
		align-items: center;
	}

	.cruise-sticky .van-cell {
		padding: 40px 0 !important;
		overflow: unset !important;
	}

	.cruise-sticky .van-cell::after,
	.cruise-sticky .van-collapse-item--border::after {
		width: 100%;
		left: 0;
	}

	.cruise .sticky_Collapse-content {
		display: flex;
		flex-direction: column;
	}

	.cruise .sticky_Collapse-content img {
		height: 40px;
		width: 40px;
	}

	.cruise-sticky .van-collapse-item__content {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.sticky_Collapse-content font {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		margin-left: 20px;
	}

	.cruise .content01-b {
		margin-left: 20px;
		border-left: 1px solid #f1f1f1;
		padding-left: 40px;
		box-sizing: border-box;
		display: block;
		padding-bottom: 40px;
	}

	.cruise .content01-b div {
		width: 550px;
	}

	.cruise .content01-t {
		display: flex;
	}

	.cruise .cruise-sticky_overview div {
		font-size: 26px;
		line-height: 48px;
		color: #666;
		padding-bottom: 20px;
	}

	.cruise .cruise-sticky_cost {
		margin-bottom: 30px;
	}

	.cruise-sticky_cost h3 {
		font-size: 26px;
		color: #333;
		font-weight: bold;
		display: flex;
		align-items: center;
		position: relative;
	}

	.cruise-sticky_cost h3::before {
		content: "*";
		color: #ffcc03;
		font-size: 24px;
		margin-top: 5px;
		margin-right: 20px;
	}

	.cruise-sticky_cost div {
		margin-top: 24px;
		margin-left: 26px;
		margin-right: 0;
		font-size: 22px;
		color: #666;
		line-height: 48px;
	}

	.cruise-sticky {
		padding-bottom: 120px;
	}
</style>
